import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";
import React from "react";
import { FlagType, FlagTypeLabels, FlaggingConfiguration } from "../../models/ClientConfiguration/FlaggingConfiguration";
import OutlinedDiv from "../common/OutlinedDiv";

interface FlagTypeSelectProps {
  value: FlaggingConfiguration[];
  onChange: (value: FlaggingConfiguration[]) => void;
  disabled?: boolean;
}

const FlagTypeSelect: React.FC<FlagTypeSelectProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const handleSwitchChange = (isChecked: boolean, flagValue: FlaggingConfiguration) => {
    let updatedFlags: FlaggingConfiguration[];
    if (isChecked) {
      updatedFlags = [...value, flagValue];
    } else {
      updatedFlags = value.filter((flag) => flag.flagType !== flagValue.flagType);
    }

    onChange(updatedFlags);
  };

  return (
    <OutlinedDiv label="Flag Types">
      <div className="flex flex-col gap-2 h-full justify-center">
        {Object.values(FlagType)
          .filter((value) => value !== FlagType.FileExtension && value !== FlagType.MigrationEntityBlockedByUser)
          .map((flag) => {
            const flagValue = flag as FlagType;
            return (
              <div
                key={flagValue}
                className={cn(
                  "flex w-full justify-between items-center",
                  disabled && "opacity-50 pointer-events-none"
                )}
              >
                <Label>{FlagTypeLabels[flagValue]}</Label>
                <Switch
                  checked={value.some( flag => flag.flagType === flagValue)}
                  onCheckedChange={(checked) =>
                    handleSwitchChange(checked, {flagType: flagValue} as FlaggingConfiguration)
                  }
                />
              </div>
            );
          })}
      </div>
    </OutlinedDiv>
  );
};

export default FlagTypeSelect;
